import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestRevisionCurrentGet = {
    path: "/revision/current",
    method: RouteHttpVerb.GET
};
export { locationRestRevisionCurrentGet };
